var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rule-tab"},[_c('RuleConditions',{staticClass:"conditions"}),(!_vm.hasConditions)?_c('div',[_c('ShippingRuleGuide')],1):_vm._e(),_c('RuleAction',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasConditions),expression:"hasConditions"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }